<template>
  <div>
    <div
      class="top-box"
      :class="
        (hasPermission(resp.detail.detail.productId) && !isShrink) ||
        item.isAvailable
          ? ''
          : 'lock-style'
      "
    >
      <div class="left-box" :class="{ 'change-font': item.index > 999 }">
        <p class="title-course" :class="hightLight ? 'change-color' : ''">
          {{ item.index === 0 ? '内容介绍' : '第' + item.index + '节' }}
        </p>
        <img
          :src="
            require(hightLight
              ? '@/static/ic_playing.gif'
              : './images/play_blue.png')
          "
          v-if="
            (hasPermission(resp.detail.detail.productId) && !isShrink) ||
              item.isAvailable
          "
        />
        <div class="lock-img" v-else>
          <img src="./images/ico_lock.png" class="lock-ico" />
          <img src="./images/play_grey.png" />
        </div>
      </div>
      <div class="time-box">
        <div class="item-box">
          <p class="title-course" :class="hightLight ? 'change-color' : ''">
            {{ item.title }}
          </p>
          <div class="bottom-flex">
            <div class="progress-box">
              <div class="time-icon">
                <img src="./images/time_icon.png" />
                <p>
                  {{
                    dayjs(item.duration * 1000)
                      .utc()
                      .format('HH:mm:ss')
                  }}
                </p>
              </div>
              <progress
                v-if="
                  item.progress !== 0 &&
                    item.duration !== 0 &&
                    !item.isHightlight
                "
                :value="item.progress"
                :max="item.duration"
              ></progress>
              <div
                v-if="item.progress !== 0 && !item.isHightlight"
                class="T1 S3 progressLabel"
              >
                {{
                  item.duration
                    ? '已看到' +
                      Math.min(
                        100,
                        (item.progress / item.duration) * 100
                      ).toFixed(0) +
                      '%'
                    : ''
                }}
              </div>
            </div>

            <p class="time-item">
              {{ dayjs(item.updateTime).format('MM-DD') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { hasPermission } from '@/api/permission'
import { mapState } from 'vuex'

dayjs.extend(utc)

export default {
  name: 'CatelogItem',
  props: {
    item: {
      type: Object
    },
    hightLight: {
      type: Boolean
    },
    isShrink: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    dayjs,
    hasPermission
  },
  computed: {
    ...mapState('video', ['resp', 'currentVideo'])
  }
}
</script>

<style lang="scss">
.top-box {
  display: flex;
  background: #f7f8fa;
  border-radius: 10px;
  margin-bottom: 30px;
  p {
    margin: 0;
    padding: 0;
  }

  .left-box {
    width: 134px;
    margin-top: 14px;
    margin-bottom: 16px;
    padding-left: 14px;
    flex-shrink: 0;
    border-right: 1px dashed #b4b4b4;
    p {
      font-weight: bold;
      font-size: 32px;
      color: #1f1f1f;
      margin: 6px 0 0 0;
    }
    img {
      width: 44px;
      margin-top: 22px;
    }
  }
  .change-font {
    p {
      font-size: 26px;
    }
  }
  .time-box {
    display: flex;
    margin-left: 14px;
    justify-content: space-between;
    width: 100%;
    .item-box {
      width: 100%;
      .title-course {
        font-size: 32px;
        color: #1f1f1f;
        margin: 20px 0 24px;
      }
      .bottom-flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .progress-box {
          display: flex;
          align-items: center;
        }
        .time-icon {
          display: flex;
          align-items: center;
          padding: 0px 18px 0px 2px;
          background: #e8e8e8;
          border-radius: 23px;
          height: 46px;
          img {
            width: 40px;
            height: 40px;
            margin-right: 10px;
          }
          p {
            color: #1f1f1f;
            font-size: 24px;
          }
        }
        .time-item {
          color: #1f1f1f;
          font-size: 24px;
          line-height: 46px;
          background: #e8e8e8;
          padding: 0 18px;
          border-radius: 20px;
          margin-right: 14px;
        }
      }
    }
  }
}
.lock-style {
  .left-box {
    p {
      color: #7a7a7a;
    }
    .lock-img {
      display: flex;
      align-items: center;
      .lock-ico {
        margin-right: 12px;
      }
    }
  }
  .time-box {
    .item-box {
      .title-course {
        color: #7a7a7a;
      }
      .bottom-flex {
        .time-icon {
          p {
            color: #7a7a7a;
          }
        }
        .time-item {
          color: #7a7a7a;
        }
      }
    }
  }
}

progress {
  width: 100px;
  height: 6px;
  border-radius: 3px;
  /*custom*/
  margin-left: 14px;
}

/* 表示总长度背景色 */
progress::-webkit-progress-bar {
  background-color: #ebebeb;
  border-radius: 3px;
}

/* 表示已完成进度背景色 */
progress::-webkit-progress-value {
  background: #046bcc;
  border-radius: 3px;
}

.progressLabel {
  margin-left: 10px;
  width: 80px;
  text-align: center;
}
.change-color {
  color: #046bcc !important;
}
</style>
